<div class="hint">Please select one option</div>
<ion-list>
  <ion-radio-group #radio>
    @for (option of radioOptions; track option) {
      <ion-item lines="none">
        <ion-label>{{ option.label }}</ion-label>
        <ion-radio mode="md" slot="start" color="secondary" [value]="option.value"></ion-radio>
      </ion-item>
    }
  </ion-radio-group>
</ion-list>
<ion-item class="other-container" [ngClass]="!showOther ? 'ion-hide' : ''" lines="none">
  <ion-input
    #input
    tabindex="-1"
    type="text"
    autocorrect="on"
    autocapitalize="on"
    enterkeyhint="done"
    maxlength="100"
    class="questions"
    label="Please provide details (required)"
    labelPlacement="stacked"
    [formControl]="field"
    (keyup)="onKeyUp($event)"
  (click)="onClick($event)"></ion-input>
</ion-item>
<ion-item class="character-count" [ngClass]="!showOther ? 'ion-hide' : ''" lines="none">{{ length }}/100</ion-item>
